
import GbHeader from '@geekbrains/geekbrains-ui-kit/src/elements/Header/Header.vue'
import GbFooter from '@geekbrains/geekbrains-ui-kit/src/elements/Footer/Footer.vue'
import { createNamespacedHelpers } from 'vuex'
import { usedeskScript, usedeskTooltipScript } from '@/utils/client/usedesk'
import { gbLocalStorage, getCookie } from '~/utils/helpers'
const { mapState } = createNamespacedHelpers('header')

export default {
  name: 'ClientDefault',
  components: {
    GbHeader,
    GbFooter
  },

  data() {
    return {
      footerData: [{ children: [] }],
      usedeskPaths: ['/education', '/lessons'],

      isAuth: false,
      userInfo: null,
      isDarkMode: false
    }
  },

  async fetch() {
    const jwtToken = getCookie(
      'jwt_token',
      this.$ssrContext?.req?.headers.cookie
    )

    const Authorization = jwtToken ? `Bearer ${jwtToken}` : null

    this.$store.commit('user/set', { type: 'jwtToken', payload: Authorization })
    this.isAuth = !!jwtToken

    try {
      await this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'profile',
          'line_second'
        ]
      })

      const { data: footer = [] } =
        await this.$repositories.navigation.getMenuListByType(
          'main',
          Authorization,
          this.$route.fullPath,
          'footer'
        )

      this.footerData = footer[0].items
    } catch (e) {
      console.error('Layout -> default.vue: ', e)
    }

    this.setDarkMode()
  },

  head() {
    const path = this.routePath
    const isDesktop = this.$device.isDesktop

    return {
      script: [usedeskScript(this.isAuth, path, isDesktop)]
    }
  },

  computed: {
    ...mapState(['currentHeaderData']),

    routePath() {
      const routeArr = this.$route.path.split('/')

      if (routeArr.length > 1) {
        return routeArr[1]
      }

      return ''
    },

    isFooterShowing() {
      const exceptions = ['calendar']

      return !exceptions.includes(this.routePath)
    },

    isBannerSticky() {
      const paths = ['']

      return paths.includes(this.routePath)
    }
  },

  watch: {
    $route() {
      this.setDarkMode()

      if (!this.usedeskPaths.includes(this.$route.fullPath)) {
        document.querySelector('#usedesk-messenger')?.remove()
      }
      document.querySelector('#fasttrack-MainFrame')?.remove()
      document.querySelector('#fasttrack-InviteFrame')?.remove()

      this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'line_second'
        ]
      })

      this.$refs.stickyBanner?.getBannerData()
    }
  },

  beforeMount() {
    const jwtToken = getCookie('jwt_token')
    const Authorization = jwtToken ? `Bearer ${jwtToken}` : null

    this.isAuth = !!jwtToken
    this.$store.commit('user/set', { type: 'jwtToken', payload: Authorization })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    window.__widgetInitCallback = async widget => {
      let token = widget.getChatToken() || gbLocalStorage.get('chat_token')
      if (!token) {
        const dbToken = await this.$api.users.getUsedeskToken()
        token = dbToken.token

        if (token) {
          gbLocalStorage.set('chat_token', token)
        }
      }
      widget.userIdentify({ token })
    }

    window.__usedeskWidgetFirstClientMessageCallback = () => {
      const token = window.usedeskMessenger.getChatToken()
      if (token) {
        this.$api.users.setUsedeskToken(token)
        gbLocalStorage.set('chat_token', token)
      }
    }
  },

  async mounted() {
    const Authorization = this.$store.state.user.jwtToken
    let userInfo = {}

    try {
      const [userInfoPromise] = await Promise.allSettled([
        this.isAuth && this.$repositories.users.getUserInfo()
      ])

      userInfo =
        userInfoPromise.status === 'fulfilled' ? userInfoPromise.value.data : {}

      if (userInfo) {
        const { roles } = userInfo
        const isTeacher = roles && roles.length && roles.includes('teacher')
        const isMentor = roles && roles.length && roles.includes('mentor')

        if (isTeacher) {
          gbLocalStorage.set('hide-referral', true)
        } else {
          gbLocalStorage.remove('hide-referral')
        }

        this.$store.commit('user/set', {
          type: 'userInfo',
          payload: userInfo
        })

        this.$store.commit('user/set', {
          type: 'isTeacher',
          payload: !!isTeacher
        })

        this.$store.commit('user/set', {
          type: 'isMentor',
          payload: !!isMentor
        })

        this.userInfo = userInfo
      }
    } catch (e) {
      console.error(e)
    }

    try {
      await this.$store.dispatch('header/fetchHeaderData', {
        path: this.$route.fullPath,
        types: [
          'line',
          'teacher-line',
          'burger',
          'teacher-burger',
          'profile',
          'line_second',
          'button'
        ],
        forced: true
      })

      const { data: footer = [] } =
        await this.$repositories.navigation.getMenuListByType(
          'main',
          Authorization,
          this.$route.fullPath,
          'footer'
        )

      this.footerData = footer[0].items
    } catch (e) {
      console.error('Layout -> default.vue: ', e)
    }

    usedeskTooltipScript()
  },

  methods: {
    setDarkMode() {
      const routes = ['/referral']
      this.isDarkMode = routes.includes(this.$route.path)
    }
  }
}
